module.exports = __webpack_public_path__ + "static/media/VICTORY5.ef5b443.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/VICTORY5.mp3
// module id = 305
// module chunks = 1 2 3